import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { stats, testimonials } from '@/mocks/home';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'website_alt') {
        body.append(key, value as string);
      }
    });
    fetch('https://readdy.ai/api/form/d9pmkb5i2vhsdh2d37dg', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        let parsed: any = {};
        try { parsed = JSON.parse(text); } catch { parsed = { message: text }; }
        if (res.ok && parsed?.code === 'OK') {
          setFormStatus('success');
          form.reset();
        } else {
          const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
          setFormError(msg);
          setFormStatus('error');
        }
      })
      .catch(() => {
        setFormError('网络错误，请稍后重试');
        setFormStatus('error');
      });
  };

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
              <a href="/" className="hover:text-primary-600 transition-colors">首页</a>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              关于91在线观看
            </h1>
            <p className="text-sm text-foreground-500">
              高清视频免费播放平台，用心服务每一位用户
            </p>
          </div>
        </div>

        <section className="py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  <strong>91在线观看</strong>成立于2018年，是一家专注于高清视频在线播放的互联网平台。我们致力于为广大用户提供海量优质视频资源，涵盖电影、电视剧、综艺、动漫、纪录片、短视频等多种内容类型，满足不同用户群体的观影需求。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  秉承"让每个人都能轻松享受高清视频"的理念，91在线观看坚持免费服务、无需下载、即点即看的产品策略。我们通过自建CDN加速网络，确保全国用户都能获得流畅的高清观影体验。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  经过多年的发展，91在线观看已积累了超过5000万月活跃用户，内容资源库超过30万部，覆盖全球200+个CDN节点。我们始终坚持以用户为中心，不断优化产品体验，提升内容质量。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  未来，91在线观看将继续深耕视频领域，探索AI智能推荐、4K超清画质、VR沉浸式观影等新技术，为用户带来更加优质的娱乐体验。
                </p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20collaborative%20creative%20workspace%20with%20warm%20ambient%20lighting%2C%20designers%20working%20on%20large%20monitors%20displaying%20video%20content%2C%20comfortable%20modern%20office%20with%20plants%20and%20natural%20light%2C%20warm%20golden%20and%20cream%20tones%2C%20professional%20creative%20studio%20style&width=800&height=500&seq=about-brand&orientation=landscape"
                  alt="91在线观看品牌形象"
                  title="91在线观看 - 高清视频免费播放平台"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
                平台数据
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                数据见证成长，品质赢得信赖
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
              {stats.map((stat) => (
                <div key={stat.id} className="bg-background-50 rounded-xl p-6 text-center">
                  <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">{stat.value}</p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                来自用户的真实评价
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((item) => (
                <div key={item.id} className="bg-background-100 rounded-xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{item.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <img src={item.avatar} alt={item.name} className="w-10 h-10 rounded-full object-cover" loading="lazy" />
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.date}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                如有任何问题或建议，欢迎随时与我们联系
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-1 space-y-5">
                <div className="bg-background-50 rounded-xl p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</p>
                    <p className="text-sm text-foreground-500">service@91zaixianguankan.com</p>
                  </div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">客服电话</p>
                    <p className="text-sm text-foreground-500">400-888-9191</p>
                  </div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">公司地址</p>
                    <p className="text-sm text-foreground-500">北京市朝阳区光华路9号</p>
                  </div>
                </div>
                <div className="bg-background-50 rounded-xl p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 shrink-0">
                    <i className="ri-time-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">工作时间</p>
                    <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="bg-background-50 rounded-xl p-6">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-5">发送消息</h3>
                  <form data-readdy-form="" onSubmit={handleSubmit} className="space-y-4">
                    <div className="honeypot-wrap">
                      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                        <input type="text" id="about-name" name="name" required className="w-full px-4 py-3 rounded-lg bg-background-100 text-sm text-foreground-900 border border-background-200 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="您的姓名" />
                      </div>
                      <div>
                        <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                        <input type="email" id="about-email" name="email" required className="w-full px-4 py-3 rounded-lg bg-background-100 text-sm text-foreground-900 border border-background-200 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="your@email.com" />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="about-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                      <input type="text" id="about-subject" name="subject" className="w-full px-4 py-3 rounded-lg bg-background-100 text-sm text-foreground-900 border border-background-200 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all" placeholder="消息主题" />
                    </div>
                    <div>
                      <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容</label>
                      <textarea id="about-message" name="message" required maxLength={500} rows={4} className="w-full px-4 py-3 rounded-lg bg-background-100 text-sm text-foreground-900 border border-background-200 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none" placeholder="请输入您的消息（最多500字）"></textarea>
                      <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                    </div>
                    <div className="flex items-center justify-between">
                      {formStatus === 'success' && (
                        <p className="text-sm text-primary-600 font-medium">消息已发送，我们会尽快回复您！</p>
                      )}
                      {formStatus === 'error' && (
                        <p className="text-sm text-primary-600 font-medium">{formError}</p>
                      )}
                      {formStatus === 'idle' && <div></div>}
                      <button type="submit" className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                        发送消息
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                快速解答您的疑问
              </p>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: '91在线观看是否需要注册？', a: '观看视频无需注册，打开网站即可直接观看所有免费视频资源。注册账号后可以同步观看记录和收藏视频。' },
                { q: '视频画质如何？', a: '我们提供1080P高清画质，部分热门视频支持4K超清画质。您可以根据网络情况自由选择画质。' },
                { q: '支持哪些设备观看？', a: '91在线观看支持手机、平板、电脑等多种设备，无需下载APP，浏览器直接访问即可观看。' },
                { q: '视频更新频率如何？', a: '热门综艺和电视剧通常在播出后24小时内更新，电影资源也会持续更新，确保您能第一时间看到最新内容。' },
                { q: '观看需要付费吗？', a: '所有视频资源均免费观看，无需付费或开通会员，我们始终坚持免费服务的原则。' },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-xl">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform shrink-0"></i>
                  </summary>
                  <div className="px-6 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于91在线观看',
          description: '91在线观看品牌介绍、平台数据、用户口碑与联系方式',
          isPartOf: { '@type': 'WebSite', name: '91在线观看', url: 'https://www.91zaixianguankan.com/' },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91zaixianguankan.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.91zaixianguankan.com/about' },
            ],
          },
        }) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            { '@type': 'Question', name: '91在线观看是否需要注册？', acceptedAnswer: { '@type': 'Answer', text: '观看视频无需注册，打开网站即可直接观看所有免费视频资源。注册账号后可以同步观看记录和收藏视频。' } },
            { '@type': 'Question', name: '视频画质如何？', acceptedAnswer: { '@type': 'Answer', text: '我们提供1080P高清画质，部分热门视频支持4K超清画质。您可以根据网络情况自由选择画质。' } },
            { '@type': 'Question', name: '支持哪些设备观看？', acceptedAnswer: { '@type': 'Answer', text: '91在线观看支持手机、平板、电脑等多种设备，无需下载APP，浏览器直接访问即可观看。' } },
            { '@type': 'Question', name: '视频更新频率如何？', acceptedAnswer: { '@type': 'Answer', text: '热门综艺和电视剧通常在播出后24小时内更新，电影资源也会持续更新，确保您能第一时间看到最新内容。' } },
            { '@type': 'Question', name: '观看需要付费吗？', acceptedAnswer: { '@type': 'Answer', text: '所有视频资源均免费观看，无需付费或开通会员，我们始终坚持免费服务的原则。' } },
          ],
        }) }} />
      </main>
      <Footer />
    </>
  );
}